import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//我的课程
export const getMyCourse = data => http.get('/mini/UserCourseChapter?status='+ data.status,data);

//用户信息
export const getUser = data => http.get('/mini/User');

//编辑个人信息
export const EditUser = data => http.post('/mini/User',data);

//邀请好友列表
export const getMyInvite = data => http.get('/mini/Invite');

//消息列表
export const getMyMessageList = data => http.get('/mini/Message');

//消息详情
export const getMyMessageDetail = data => http.get('/mini/Message/'+data.uuid);

//轮播
export const getBannerTopList = data => http.get('/mini/Banner',data);

//更新用户首次登录状态
export const UserSetFirstLogin = data => http.get('/mini/UserSetFirstLogin',data);

export const SendSmsCode = data => http.post('/common/SendSmsCode',data);

export const getMemberOrder = data => http.get('/mini/MemberOrder/'+data.id);
